export const SUCCESS = 'success';
export const FAIL = 'fail';
export const WARNING = 'warning';